"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrustReview = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _lab = require("@material-ui/lab");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      height: '100%'
    },
    rating: {
      color: '#C8B274'
    }
  };
});

var TrustReview = function TrustReview(_ref) {
  var className = _ref.className,
      _ref$avatarSrc = _ref.avatarSrc,
      avatarSrc = _ref$avatarSrc === void 0 ? null : _ref$avatarSrc,
      reviewerName = _ref.reviewerName,
      stars = _ref.stars,
      content = _ref.content,
      props = _objectWithoutProperties(_ref, ["className", "avatarSrc", "reviewerName", "stars", "content"]);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.CardHeader, {
    className: classes.header,
    avatar: /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.avatar,
      src: avatarSrc
    }),
    title: /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h5"
    }, reviewerName),
    subheader: /*#__PURE__*/_react.default.createElement(_lab.Rating, {
      name: "disabled",
      value: stars,
      readOnly: true,
      className: classes.rating
    })
  }), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    gutterBottom: true
  }, content)));
};

exports.TrustReview = TrustReview;
TrustReview.propTypes = {
  avatarSrc: _propTypes.default.string,
  reviewerName: _propTypes.default.string.isRequired,
  stars: _propTypes.default.number.isRequired,
  content: _propTypes.default.string.isRequired
};
var _default = TrustReview;
exports.default = _default;